// This file should be kept in sync with stylesheets/shared/_break-points.scss
export const breakExtraSmall = 450
export const breakSmall = 700
export const breakLarge = 800
